import { h, Component } from 'preact';
import { canUser } from 'utils/roles';

import Button from 'components/button/button';
import { addMovie } from 'components/movies/addMovieModal';

import s from 'components/movies/addMovieButton.sss';

export default class AddMovieButton extends Component {

	constructor(props) {
		super(props);
		this.addMovie = this.addMovie.bind(this);
	}

	async addMovie() {
		const newMovie = await addMovie();
		if (!newMovie) return; // User cancelled or no movie was created

		// Navigate to editor - use base_movie_id for URL if available
		const urlId = newMovie.base_movie_id || newMovie.id;
		window.location.hash = `#movies/${urlId}/info`;
	}

	render() {
		return (
			<Button primary icon="plus" class={s.addMovieButton} onClick={this.addMovie} disabled={!canUser('write')}>
				New movie
			</Button>
		);
	}
}